import { useSnackbar } from 'notistack';
import { useCallback } from 'react';

export function useSuccessFailureNotification() {
  const { enqueueSnackbar } = useSnackbar();

  const callWithNotification = useCallback(
    async (
      callback: () => Promise<boolean>,
      successMessage: string,
      failureMessage = 'Sorry, something went wrong. Please try again later.',
    ) => {
      try {
        const success = await callback();
        if (!success) {
          throw new Error('Failed to update');
        }
        enqueueSnackbar(successMessage, { variant: 'success' });
      } catch {
        enqueueSnackbar(failureMessage, { variant: 'error' });
      }
    },
    [enqueueSnackbar],
  );

  return { callWithNotification };
}
